export default async function apiCall( {
    url="",
    method = "post",
    headers={},
 }, body:any) {
    try {
      //const objErrorApi = { resultado: { "idresul": 0,  "desresul": "" } };
     
      const response = await fetch(url, {
        method,
        body,
        headers,
      });

      console.log("______________response.status: ", response.status);
      console.log("______________response.status: ", response);

      if (response.status == 200)
          return response.json(); 
      else{
        return response.json(); 
            /* console.log('else')
            objErrorApi.resultado.idresul = response.status;
            objErrorApi.resultado.desresul = response.statusText;
            return objErrorApi; */
      }   
      
    } catch (error) {
      console.log("catch api (error): ", error);
      Promise.reject(error);
      //return(error)
    }
} 

